import React, { Component } from 'react';
import { AdSlot, DFPManager } from 'react-dfp';
import PropTypes from 'prop-types';
import { makeStaticAdsResponsive } from '../utils';

export class Ad extends Component {
  componentDidMount() {
    this.handleResponsiveAds(300);
  }

  handleResponsiveAds(seconds) {
    let i = 0;
    const checkStaticAds = (callback) => {
      DFPManager.getGoogletag().then((gt) => {
        const adBoxes = document.getElementsByClassName('adBox');
        const adSlots = Array.prototype.map.call(adBoxes, (adBox) => {
          const { id } = adBox;
          const slot = document.getElementById(id);
          const slotFrame = slot ? slot.querySelectorAll('iframe')[0] : undefined;
          const slotImg = slotFrame ? slotFrame.contentDocument.body.getElementsByTagName('img')[0] : undefined;
          const imgSrc = slotImg ? slotImg.src : undefined;
          return { id, slotFrame, slotImg, imgSrc };
        });
        const allFramesExist = adSlots.every(adSlot => typeof adSlot.slotFrame !== 'undefined');
        const allImgsExist = adSlots.every(adSlot => typeof adSlot.slotImg !== 'undefined');
        const allImgSrcsExist = adSlots.every(adSlot => typeof adSlot.imgSrc !== 'undefined');
        i++;
        if ((allFramesExist && allImgsExist && allImgSrcsExist) || (i === 20)) {
          clearInterval(interval);
          for (const { slotFrame, slotImg, id } of adSlots) {
            if (!document.getElementById(id).classList.contains('handled')) {
              makeStaticAdsResponsive(slotFrame, slotImg, id);
              document.getElementById(id).classList.add('handled');
            }
          }
        }
      });
    };
    const interval = setInterval(checkStaticAds, seconds);
  }

  render() {
    const { data, isClient } = this.props;
    // Ad Sizes by Device:
    // Mobile: [414, 736], [300, 250], [300, 100]
    // Tablet Portrait: [1280, 400], [300, 250], [300, 100]
    // Tablet Landscape & Desktop: [1280, 400], [300, 100]
    let isMobileOnly, isTabletPortrait;
    if (isClient) {
      isMobileOnly = window.innerWidth < 768;
      isTabletPortrait = window.innerWidth >= 768 && window.innerWidth <= 991;
    }
    const adSizes = isMobileOnly ? [[414, 736], [300, 250], [300, 100]] : isTabletPortrait ? [[1280, 400], [300, 250], [300, 100]] : [[1280, 400], [300, 100]];

    return (
        <AdSlot
            sizes={adSizes}
            targetingArguments={data}
        />
    );
  }
}

Ad.propTypes = {
  data: PropTypes.object,
};

export default Ad;
